import { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { sendAnalytics, GTM_EVENT_TYPES, analyticsUserType } from 'analytics';
import { useIsNoData } from 'utils';
import { useAppSelector } from 'store/hooks';
import { ContactBlock } from 'components/layout/navigation/contactBlock';
import { useGetScreenSize } from 'utils';
import { PATH } from 'interfaces/pathTypes';
import { Title } from 'components/layout/header/title';
import { Quote } from './quote';

import './quotes.scss';

export const Quotes = (): JSX.Element => {
  const quotes = useAppSelector((state) => state.customerData.quotes);
  const isAgent = useAppSelector((state) => state.authentication.isAgent);
  const redirect = useIsNoData({ quotes, checkQuotes: true });
  const { isTablet, isMobile } = useGetScreenSize();

  useEffect(() => {
    sendAnalytics({
      event: GTM_EVENT_TYPES.PAGE_VIEW,
      detail: {
        virtualpage_title: 'Quotes',
        virtualpage: PATH.QUOTES,
        virtualpage_url: document.location.href,
        usertype: analyticsUserType(isAgent)
      }
    });
  }, []);

  if (redirect) {
    return redirect;
  }

  return (
    <Container className="page-container" fluid={isTablet || isMobile}>
      <Title title="YOUR QUOTES" icon="document-circle" id="quotes" />
      <div className="quotes-container">
        <Row sm={2} xs={1} lg={3}>
          {quotes &&
            quotes.map((quote) => (
              <Col key={quote.quoteRef} data-testid="quote-card">
                <Quote quote={quote} />
              </Col>
            ))}
        </Row>
      </div>
      <ContactBlock />
    </Container>
  );
};
